import { _, React, classNames, withStyles, StyledProps } from '@api'
import { CentricTheme } from 'centric-ui-components'
import { TextInput } from './'

const styles = (theme: CentricTheme) => ({
  colorContainer: {
    position: 'relative'
  },
  colorBox:       {
    width:        theme.spacing() * 3,
    height:       theme.spacing() * 3,
    position:     'absolute',
    top:          theme.spacing(),
    right:        0,
    borderRadius: 2
  },
  disabled:       {
    color:      'rgba(27, 27, 27, 0.87)',
    fontSize:   14,
    '&:before': {
      borderBottom: '0 !important'
    }
  },
  colorClickable: {
    cursor: 'pointer'
  }
})

export type RGB = { red?: string | number, green?: string | number, blue?: string | number }
export type Color = RGB | HSB | string
export type HSB = { hue?: number, saturation?: number, brightness?: number}

interface MyProps extends StyledProps {
  color?: Color
  label?: string
  editMode?: boolean
  onClickColor: (e: React.SyntheticEvent<HTMLDivElement>) => void
  required?: boolean
  error?: boolean
  rgb?: Color
}

export class ColorFieldComponent extends React.Component<MyProps> {
  static defaultProps = {
    editMode: true,
    required: false,
    error: false,
    onClickColor: () => {}
  }

  render() {
    const {props: {label, color, classes, onClickColor, className, editMode, required, error, rgb}} = this
    let value = color
    let rgbVal = ''
    if (_.isObject(color)) {
      var c = color as RGB
      value = `rgb(${c.red}, ${c.green}, ${c.blue})`
    }

    if (_.isObject(rgb)) {
      var c = rgb as RGB
      rgbVal = `rgb(${c.red}, ${c.green}, ${c.blue})`
    }

    return (
      <div className={classNames(classes.colorContainer, className, {[classes.colorClickable]: editMode})} onClick={editMode && onClickColor ? onClickColor : undefined}>
        <TextInput disabled required={required} error={error} label={label} value={value as string || '--'} />
        <div style={{backgroundColor: rgbVal ? rgbVal : value ? value.toString() : ''}} className={classes.colorBox}/>
      </div>
    )
  }
}

@(withStyles as any)(styles)
export class ColorField extends ColorFieldComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/ColorField.tsx